import { render, staticRenderFns } from "./CompraTX.vue?vue&type=template&id=129d804e&"
import script from "./CompraTX.vue?vue&type=script&lang=js&"
export * from "./CompraTX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports